'use client';

import { styled } from '@mui/material';

import { KeyboardArrowRight } from '../../../../icons';
import { Button } from '../../../Button';

export const StyledTableMobileCard = styled(Button)(({ theme }) => ({
  width: '100%',
  height: 80,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(4),
  borderRadius: theme.spacing(4),
  background: theme.palette.surface2,
  textTransform: 'none',

  '&:active, :hover': {
    background: theme.palette.surface2,
  },

  '& .MuiTypography-button1': {
    width: '100%',
    height: '100%',
    justifyContent: 'space-between',
    textTransform: 'none',
  },
}));

export const TableMobileCardIcon = styled(KeyboardArrowRight)(({ theme }) => ({
  width: 24,
  height: 24,
  color: theme.palette.text3,
}));
